import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from "angular-datatables";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select2Module } from 'ng-select2-component';
import { ToastrModule } from 'ngx-toastr';
import { DirectivesModule } from '../../directives/directives.module';

import { ShortcutComponent } from './shortcut/shortcut.component';
import { OnlinePaymentComponent } from './online-payment/online-payment.component';
import { CarruselComponent } from './carrusel/carrusel.component';
import { MenuComponent } from './menu/menu.component';
import { LastUpdateComponent } from './last-update/last-update.component';
import { AnimationActionCardComponent } from './animation-action-card/animation-action-card.component';
import { AnimationActionUserCardComponent } from './animation-action-user-card/animation-action-user-card.component';
import { LeadMessageModalComponent } from '../leads/edit/modal/lead-message-modal.component';
import { AnimationActionCardSupervisorComponent } from './animation-action-card-supervisor/animation-action-card-supervisor.component';
import { AnimationActionResultTotalComponent } from './animation-action-result-total/animation-action-result-total.component';
import { AnimationActionResultDistributorComponent } from './animation-action-result-distributor/animation-action-result-distributor.component';
import { AnimationActionGoalMatrixComponent } from './animation-action-goal-matrix/animation-action-goal-matrix.component';
import { LocalCampaignCardComponent } from './local-campaign-card/local-campaign-card.component';
import { LocalCampaignTestSendComponent } from './local-campaign-test-send-modal/local-campaign-test-send-modal.component';
import { LocalCampaignOrderListCardComponent } from './local-campaign-order-list-card/local-campaign-order-list-card.component';
import { HoursLeadsPipe } from '../../pipes/media-hours-leads';
import { LocalCampaignHtmlModalComponent } from './local-campaign-html-modal/local-campaign-html-modal.component';
import { LocalCampaignStatisticsEmailComponent } from './local-campaign-statistics-email/local-campaign-statistics-email.component';
import { LocalCampaignStatisticsSmsComponent } from './local-campaign-statistics-sms/local-campaign-statistics-sms.component';
import { LocalCampaignConditionsModalComponent } from './local-campaign-conditions-modal/local-campaign-conditions-modal.component';
import { CampaignCrmStatisticsComponent } from './campaign-crm-statistics/campaign-crm-statistics.component';
import { VisitNumberPipe } from 'src/app/pipes/visit-number';
import { DistributorCommonFilterComponent } from './distributor-common-filter/distributor-common-filter.component';
import { CampaignContactImpactHistoricComponent } from './campaign-contact-impact-historic/campaign-contact-impact-historic.component';
import { LocalCampaignLegendComponent } from './local-campaign-legend/local-campaign-legend.component';
import { AnimationActionGlobalResultCardComponent } from './animation-action-global-result-card/animation-action-global-result-card.component';
import { DeclinedReasonComponent } from './declined-reason-modal/declined-reason-modal.component';
import { AnimationActionGoalGlobalMatrixComponent } from './animation-action-goal-global-matrix/animation-action-goal-global-matrix.component';
import { documentTrackingDirective } from 'src/app/directives/documentTracking.directive';
import { AddTokenPipe } from 'src/app/pipes/addToken';
import { DashboardComponent } from '../leads/dashboard/dashboard.component';
import { BannerComponent } from './banner/banner.component';
import { DspStatisticComponent } from './dsp-statistic/dsp-statistic.component';
import { PuntoapuntoLocalCampaignCardComponent } from './puntoapunto-local-campaign-card/puntoapunto-local-campaign-card.component';
import { PuntoapuntoEntityDataBarComponent } from './puntoapunto-entity-data-bar/puntoapunto-entity-data-bar.component';
import { FamilySelectorComponent } from './family-selector/family-selector.component';
import { PuntoapuntoLocalCampaignTestSendComponent } from './puntoapunto-local-campaign-test-send-modal/puntoapunto-local-campaign-test-send-modal.component';
import { PuntoapuntoLocalCampaignConditionsModalComponent } from './puntoapunto-local-campaign-condition-modal/puntoapunto-local-campaign-conditions-modal.component';
import { PuntoapuntoLocalCampaignOrderListCardComponent } from './puntoapunto-local-campaign-order-list-card/puntoapunto-local-campaign-order-list-card.component';
import { PuntoapuntoLocalCampaignHtmlModalComponent } from './puntoapunto-local-campaign-html-modal/puntoapunto-local-campaign-html-modal.component';
import { PuntoapuntoDeclinedReasonComponent } from './puntoapunto-declined-reason-modal/puntoapunto-declined-reason-modal.component';
import { PuntoapuntoLocalCampaignStatisticsEmailComponent } from './puntoapunto-local-campaign-statistics-email/puntoapunto-local-campaign-statistics-email.component';
import { MyServiceActionCardComponent } from './myservice-action-card/myservice-action-card.component';
import { MyServiceActionDetailCardComponent } from './myservice-action-detail-card/myservice-action-detail-card.component';
import { MyServiceActionUserCardComponent } from './myservice-action-user-card/myservice-action-user-card.component';
import { MyServiceActionResultGlobaComponent } from './my-service-action-result-global/my-service-action-result-global.component';
import { MyServiceActionResultUserComponent } from './my-service-action-result-user/my-service-action-result-user.component';
import { AnimationAmazonCardComponent } from './animation-amazon-card/animation-amazon-card.component';
import { KpiLastDatePipe } from 'src/app/pipes/kpi-last-date.pipe';
import { KpiGlobalFiltersComponent } from '../kpis/shared/kpi-global-filters/kpi-global-filters.component';
import { CampaignGalleryModalComponent } from './campaign-gallery-modal/campaign-gallery-modal.component';
import { PopupComponent } from './popup/popup.component';
import { SupportWidgetComponent } from './support-widget/support-widget.component';
import { AnimationUserDataComponent } from '../animation/animation-user-data/animation-user-data.component';

@NgModule({
  declarations: [
    ShortcutComponent,
    BannerComponent,
    OnlinePaymentComponent,
    CarruselComponent,
    LastUpdateComponent,
    MenuComponent,
    AnimationActionCardComponent,
    AnimationAmazonCardComponent,
    MyServiceActionCardComponent,
    MyServiceActionDetailCardComponent,
    MyServiceActionUserCardComponent,
    AnimationActionGlobalResultCardComponent,
    AnimationActionCardSupervisorComponent,
    AnimationActionUserCardComponent,
    AnimationActionResultTotalComponent,
    AnimationActionResultDistributorComponent,
    AnimationActionGoalMatrixComponent,
    AnimationActionGoalGlobalMatrixComponent,
    LeadMessageModalComponent,
    HoursLeadsPipe,
    VisitNumberPipe,
    AddTokenPipe,
    LocalCampaignCardComponent,
    LocalCampaignTestSendComponent,
    DeclinedReasonComponent,
    LocalCampaignOrderListCardComponent,
    LocalCampaignHtmlModalComponent,
    LocalCampaignStatisticsEmailComponent,
    LocalCampaignStatisticsSmsComponent,
    LocalCampaignConditionsModalComponent,
    CampaignCrmStatisticsComponent,
    DistributorCommonFilterComponent,
    CampaignContactImpactHistoricComponent,
    LocalCampaignLegendComponent,
    documentTrackingDirective,
    DashboardComponent,
    DspStatisticComponent,
    FamilySelectorComponent,
    PuntoapuntoLocalCampaignCardComponent,
    PuntoapuntoEntityDataBarComponent,
    PuntoapuntoLocalCampaignTestSendComponent,
    PuntoapuntoLocalCampaignConditionsModalComponent,
    PuntoapuntoLocalCampaignOrderListCardComponent,
    PuntoapuntoLocalCampaignHtmlModalComponent,
    PuntoapuntoDeclinedReasonComponent,
    PuntoapuntoLocalCampaignStatisticsEmailComponent,
    DspStatisticComponent,
    MyServiceActionResultGlobaComponent,
    MyServiceActionResultUserComponent,
    KpiLastDatePipe,
    KpiGlobalFiltersComponent,
    CampaignGalleryModalComponent,
    PopupComponent,
    SupportWidgetComponent,
    AnimationUserDataComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    Select2Module,
    ToastrModule,
    DirectivesModule
  ],
  exports: [
    ShortcutComponent,
    BannerComponent,
    OnlinePaymentComponent,
    CarruselComponent,
    LastUpdateComponent,
    MenuComponent,
    AnimationActionCardComponent,
    AnimationAmazonCardComponent,
    MyServiceActionCardComponent,
    MyServiceActionDetailCardComponent,
    MyServiceActionUserCardComponent,
    AnimationActionGlobalResultCardComponent,
    AnimationActionCardSupervisorComponent,
    AnimationActionUserCardComponent,
    AnimationActionResultTotalComponent,
    AnimationActionResultDistributorComponent,
    AnimationActionGoalMatrixComponent,
    AnimationActionGoalGlobalMatrixComponent,
    LeadMessageModalComponent,
    HoursLeadsPipe,
    VisitNumberPipe,
    AddTokenPipe,
    LocalCampaignCardComponent,
    LocalCampaignTestSendComponent,
    DeclinedReasonComponent,
    LocalCampaignOrderListCardComponent,
    LocalCampaignHtmlModalComponent,
    LocalCampaignStatisticsEmailComponent,
    LocalCampaignStatisticsSmsComponent,
    CampaignCrmStatisticsComponent,
    DistributorCommonFilterComponent,
    CampaignContactImpactHistoricComponent,
    LocalCampaignLegendComponent,
    documentTrackingDirective,
    DashboardComponent,
    DspStatisticComponent,
    MyServiceActionResultGlobaComponent,
    MyServiceActionResultUserComponent,
    FamilySelectorComponent,
    DspStatisticComponent,
    PuntoapuntoLocalCampaignCardComponent,
    PuntoapuntoEntityDataBarComponent,
    PuntoapuntoLocalCampaignTestSendComponent,
    PuntoapuntoLocalCampaignConditionsModalComponent,
    PuntoapuntoLocalCampaignOrderListCardComponent,
    PuntoapuntoLocalCampaignHtmlModalComponent,
    PuntoapuntoDeclinedReasonComponent,
    PuntoapuntoLocalCampaignStatisticsEmailComponent,
    KpiLastDatePipe,
    KpiGlobalFiltersComponent,
    CampaignGalleryModalComponent,
    PopupComponent,
    SupportWidgetComponent,
    AnimationUserDataComponent
  ]
})
export class SharedModule { }




